module.exports = __webpack_public_path__ + "img/kamer2.3e80050a.jpg";